import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { Toaster } from 'sonner'
import { routeTree } from './routes/routeTree'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 60, retry: 1 },
  },
})

const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Toaster above BottomNav — offset by nav height (60px) + spacing */}
      <div className="print:hidden">
        <Toaster
          position="bottom-center"
          duration={3000}
          visibleToasts={2}
          offset={76}
        />
      </div>
    </QueryClientProvider>
  )
}
